import { useEffect, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";

// 360° panorama viewer with an optional cross-fading staged image overlay.
export const PreviewPano = ({ panoramaUrl, stagedUrl }) => {
  const containerRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !window.pannellum) return;
    if (viewerRef.current) {
      viewerRef.current.destroy();
      viewerRef.current = null;
    }
    viewerRef.current = window.pannellum.viewer(el, {
      type: "equirectangular",
      panorama: panoramaUrl,
      autoLoad: true,
      autoRotate: -2,
      showControls: true,
      crossOrigin: "anonymous",
      showFullscreenCtrl: true,
      backgroundColor: [11, 11, 15],
    });
    return () => {
      if (viewerRef.current) {
        viewerRef.current.destroy();
        viewerRef.current = null;
      }
    };
  }, [panoramaUrl]);

  return (
    <div className="relative w-full h-full" data-testid="preview-pano">
      <div ref={containerRef} className="w-full h-full" />
      <AnimatePresence>
        {stagedUrl && (
          <>
            <motion.img
              key={stagedUrl}
              src={stagedUrl}
              alt="AI-staged room preview"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="absolute inset-0 w-full h-full object-cover pointer-events-none z-10"
              data-testid="preview-staging-overlay"
            />
            <div className="pointer-events-none absolute top-4 left-4 z-20 bg-coral/90 backdrop-blur-md px-3 py-1.5">
              <span className="text-[10px] uppercase tracking-[0.15em] text-bone">AI-staged preview</span>
            </div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};
